import splitComponentStyles from '../split-components';
import splitImageStyles from './split-media';
